import { useEffect } from "react";
import PackageBundleItem from "@children/components/ProductPackages/PackageBundleItem";
import { useProductData } from "@/zustand/productStore";
import { useMarketingStore } from "@/zustand/emailMarketingStore";
import { ProductPackageItem } from "@/components/ProductPackages/ProductPackageItem";
import { ProductPackageItemV2 } from "@/components/ProductPackages/ProductPackageItemV2";
import { useCartData } from "@/zustand/cartStore";
import getDefaultVariantsState from "@/func/defaultVariants";

const ProductsList = ({ bundles, pickerV2 }) => {
  const { setSelectedProduct, selectedProduct, setVariants, setWarrantyState } = useCartData();
  const { freeShippingApplied } = useMarketingStore();
  const productData = useProductData();
  const freeShippingProducts = productData?.products.some((product) => product.display_name.includes("+"));

  //   colors
  const productsContent = window.post_template?.checkout_v4_products;
  const textSale = productsContent?.checkout_v4_products_textSale;
  const bestSellerBackground = productsContent?.checkout_v4_products_best_seller;
  const bestValueBackground = productsContent?.checkout_v4_products_best_value;
  const bestSellerTextColor = productsContent?.checkout_v4_products_best_seller_text_color;
  const bestValueTextColor = productsContent?.checkout_v4_products_best_value_text_color;
  const textBadge = productsContent?.checkout_v4_products_badgeTextColor;
  const cardButtonColor = window?.post_template?.checkout_v4_products?.checkout_v4_products_checkButtonCcColor;
  const cardBackground = productsContent.checkout_v4_products_CardBackground;
  const cardBackgroundSelected = productsContent.checkout_v4_products_selectedCardBackground;
  const cardBorder = productsContent.checkout_v4_products_borderColor;
  const cardBorderSelected = productsContent.checkout_v4_products_borderColorSelected;
  const textPrimary = productsContent.checkout_v4_products_textPrimary;
  const textSecondary = productsContent.checkout_v4_products_textSecondary;
  document.documentElement.style.setProperty("--checkbutton-cc-color", cardButtonColor);
  document.documentElement.style.setProperty("--card-background-active", cardBackgroundSelected);
  document.documentElement.style.setProperty("--card-border-active", cardBorderSelected);
  document.documentElement.style.setProperty("--card-border", cardBorder);
  document.documentElement.style.setProperty("--card-background", cardBackground);
  document.documentElement.style.setProperty("--card-text-primary", textPrimary);
  document.documentElement.style.setProperty("--card-text-secondary", textSecondary);
  document.documentElement.style.setProperty("--sale-text", textSale);
  document.documentElement.style.setProperty("--best-seller-background", bestSellerBackground);
  document.documentElement.style.setProperty("--best-value-background", bestValueBackground);
  document.documentElement.style.setProperty("--best-value-text", bestValueTextColor);
  document.documentElement.style.setProperty("--best-seller-text", bestSellerTextColor);
  document.documentElement.style.setProperty("--text-badge", textBadge);

  //   set default product product && variants if variants exists

  useEffect(() => {
    if (productData?.products) {
      const defaultProductIndex = productData?.products?.findIndex((item) => {
        return item.best_seller == true;
      });
      const enableVariants = productData?.enable_color_variants || productData?.enable_size_variants;
      if (enableVariants) {
        const variantsState = getDefaultVariantsState(productData);
        setVariants(variantsState);
      }
      if (productData?.preselect_warranty && productData?.add_warranty_for_product) {
        setWarrantyState(true);
      }

      const defaultProduct = defaultProductIndex
        ? productData?.products[defaultProductIndex]
        : productData?.products[0];

      handleChange(defaultProduct);
    }
  }, [productData?.products]);

  useEffect(() => {
    if (freeShippingApplied) {
      productData.changeProductsShippingPrice(0);
    }
  }, [freeShippingApplied]);

  const handleChange = (product) => {
    setSelectedProduct({
      sku: product.sku?.trim(),
      amount: product.amount,
      konnektive_id: product.konnektive_id?.trim(),
      bundle_products: product.bundle_products,
      warranty_price: product.warranty_price,
      warranty_product_id: product.warranty_product_id,
      display_name: product.display_name,
      generic_name: product.generic_name,
      bundle_title: product.bundle_title,
      price: product.price,
      old_price: product.old_price,
      shipping_price: product.shipping_price,
      promo_discounted_price: product.promo_discounted_price,
      promo_shipping_price: product.promo_shipping_price,
      fake_products: product.fake_products,
    });
  };

  return (
    <>
      {productData?.products &&
        productData?.products.map((product, i) => {
          switch (true) {
            case bundles:
              return (
                <PackageBundleItem
                  key={i}
                  product={product}
                  handleChange={() => handleChange(product)}
                  active={selectedProduct?.price === product?.price}
                  index={i}
                />
              );

            case pickerV2:
              return (
                <ProductPackageItemV2
                  key={i}
                  product={product}
                  handleChange={() => handleChange(product)}
                  active={selectedProduct?.price === product?.price}
                  index={i}
                />
              );

            default:
              return (
                <ProductPackageItem
                  key={i}
                  product={product}
                  handleChange={() => handleChange(product)}
                  active={selectedProduct?.price === product?.price}
                  index={i}
                  globalShippingLabel={freeShippingProducts}
                />
              );
          }
        })}
    </>
  );
};

export default ProductsList;
